import { render, staticRenderFns } from "./SelectFoodItems.vue?vue&type=template&id=7d57bb73&scoped=true"
import script from "./SelectFoodItems.vue?vue&type=script&lang=js"
export * from "./SelectFoodItems.vue?vue&type=script&lang=js"
import style0 from "./SelectFoodItems.vue?vue&type=style&index=0&id=7d57bb73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d57bb73",
  null
  
)

export default component.exports